import request from '@/utils/request'

export function selectStudentProjectList(params) {
  return request({
    url: '/api/v1.0/studentProject/list',
    method: 'get',
    params:params
  })
}

export function selectStudentProjectListByAccount(params) {
  return request({
    url: '/api/v1.0/studentProject/list/by-account',
    method: 'get',
    params:params
  })
}

export function selectAllStudentProject() {
  return request({
    url: '/api/v1.0/studentProject/list/all',
    method: 'get',
    params:{}
  })
}

export function selectStudentProject(id) {
  return request({
    url: '/api/v1.0/studentProject/'+id,
    method: 'get',
    params:{}
  })
}


export function addStudentProject(data) {
  return request({
    url: '/api/v1.0/studentProject/add',
    method: 'post',
    data: data
  })
}

export function updateStudentProjectByTask(projectTask) {
  return request({
    url: '/api/v1.0/studentProject/update/by-task',
    method: 'post',
    data: projectTask
  })
}

export function updateStudentProject(data) {
  return request({
    url: '/api/v1.0/studentProject/update',
    method: 'post',
    data: data
  })
}

export function deleteStudentProject(data) {
  return request({
    url: '/api/v1.0/studentProject/delete',
    method: 'delete',
    data: data
  })
}

export function updateStudentProjectAfterAudit(projectTask) {
  return request({
    url: '/api/v1.0/studentProject/update/after-audit',
    method: 'post',
    data: projectTask
  })
}

export function updateStudentProjectAfterSelection(projectTask,sno) {
  return request({
    url: '/api/v1.0/studentProject/update/after-selection/'+sno,
    method: 'post',
    data: projectTask
  })
}

export function cancelSelectedStudentProject(id) {
  return request({
    url: '/api/v1.0/studentProject/cancel-selected/'+id,
    method: 'get',
    params:{}
  })
}
